import React from 'react';
import { LoginCallback } from '@okta/okta-react';
import { AuthSdkError } from '@okta/okta-auth-js';
import { useNavigate } from 'react-router-dom';

export default function CustomLoginCallback() {
    const navigate = useNavigate();

    return (
        <LoginCallback
            errorRenderer={({ error }) => {
                if (
                    error instanceof AuthSdkError &&
                    error.message &&
                    error.message.includes(
                        'Could not load PKCE codeVerifier from storage'
                    )
                ) {
                    // Optionally, you can show a message before redirecting
                    setTimeout(() => {
                        navigate('/login', { replace: true });
                    }, 100);
                    return (
                        <div>
                            <h2>Authentication Error</h2>
                            <p>
                                There was a problem with your login session.
                                Redirecting to login...
                            </p>
                        </div>
                    );
                }
                // Default error rendering
                return (
                    <div>
                        <h2>Authentication Error</h2>
                        <pre>{error.message}</pre>
                    </div>
                );
            }}
        />
    );
}
